module.exports = __webpack_public_path__ + "bg-a169bb8ca9a0e8445c72ff7beef46f59.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/app/img/bg.jpg
// module id = 663
// module chunks = 0